import type { CommandAction } from "../../../services/commands/commands.types";
import { COMMAND_GROUPS } from "./CommandPaletteHost.copy";

/** Heading for a group id: the known label, else the id split into words ("dataApp" -> "Data app"). */
export const commandGroupLabel = (id: string): string => {
  const known = COMMAND_GROUPS.find((group) => group.id === id);
  if (known) return known.label;
  const words = id
    .replace(/([a-z0-9])([A-Z])/g, "$1 $2")
    .replace(/[._-]+/g, " ")
    .trim()
    .toLowerCase();
  return words ? words.charAt(0).toUpperCase() + words.slice(1) : id;
};

/** Known groups first, in their fixed order, then any other group in order of first appearance. */
export const listCommandGroups = (actions: readonly Pick<CommandAction, "group">[]): { id: string; label: string }[] => {
  const known = COMMAND_GROUPS.map(({ id, label }) => ({ id: id as string, label }));
  const seen = new Set(known.map((group) => group.id));
  const extra: { id: string; label: string }[] = [];
  for (const { group } of actions) {
    if (seen.has(group)) continue;
    seen.add(group);
    extra.push({ id: group, label: commandGroupLabel(group) });
  }
  return [...known, ...extra];
};

/** Id of the action that reopens the palette itself: never listed inside it. */
export const OPEN_PALETTE_ACTION_ID = "palette.open";

const ADD_WORDS = /\b(add|create|new)\b/i;
const EDIT_WORDS = /\b(edit|change|rename|duplicate)\b/i;

/** The glyph of an action's icon chip: "+" add, "E" edit, "✦" ask, "→" navigate; else its first letter. */
export const glyphFor = (action: Pick<CommandAction, "group" | "label">): string => {
  if (action.group === "assistant") return "\u2726";
  if (action.group === "navigation") return "\u2192";
  if (ADD_WORDS.test(action.label)) return "+";
  if (EDIT_WORDS.test(action.label)) return "E";
  return action.label.trim().charAt(0).toUpperCase();
};
